import '.a{display:grid;}.ssr-plugin'
import '.el{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useQuery } from '@based/sdk/react'
import { MunicipalityCard } from '@app/components/blocks/card/MunicipalityCard'
import { RegionalListMunicipalityModel } from 'functions/app/geography/list-regional-municipality'
import useMediaQuery from '@app/util/useMediaQuery'
import { pages } from '@app/util/links'

export const RegionalMunicipalitiesGrid = ({
  regionId,
}: {
  regionId: number
}) => {
  const isMobile = useMediaQuery()
  const municipalitiesQuery = useQuery('list-regional-municipality', {
    regionId,
  })
  const municipalities: RegionalListMunicipalityModel[] = Array.isArray(
    municipalitiesQuery.data,
  )
    ? municipalitiesQuery.data
    : []

  if (municipalitiesQuery.loading || municipalities.length === 0) {
    return null
  }

  return (
    <div className="a el"
      style={{
        gridTemplateColumns: isMobile
          ? 'repeat(1, minmax(250px, 1fr))'
          : 'repeat(2, minmax(250px, 1fr))',}}
    >
      {municipalities.map((municipality) => (
        <MunicipalityCard
          key={municipality.code}
          id={municipality.id}
          to={pages.municipalityPage(municipality.slug)}
          avatar={municipality.image?.src}
          title={municipality.name}
          description={(municipality.localities ?? [])
            .map((locality) => locality?.name)
            .filter(Boolean)
            .join(', ')}
          hasBadge={municipality.crowdbuildingPartner}
          plots={municipality.plots?.count ?? 0}
          initiatives={municipality.initiatives.count}
          avatars={municipality.followers ?? []}
          variant="wide"
        />
      ))}
    </div>
  )
}
